import api from '@/api';
import { QuestCostRequest } from './Cost.types';
import { API_BASE_URL } from '../../index';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportCost(params: QuestCostRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/Cost`,
    params,
  )) as unknown;

  return result as BlobPart;
}
